import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        labelOpened: { type: String, default: 'Menü öffnen'},
        labelClosed: { type: String, default: 'Menü schließen'},
    }

    toggle() {
        document.body.classList.toggle('show-ls2025-menu');

        if (document.body.classList.contains('show-ls2025-menu')) {
            this.element.setAttribute('aria-expanded', 'true');
            this.element.setAttribute('aria-label', this.labelClosedValue);
        } else {
            this.element.setAttribute('aria-expanded', 'false');
            this.element.setAttribute('aria-label', this.labelOpenedValue);
        }
    }

    disconnect() {
        document.body.classList.remove('show-ls2025-menu');
        this.element.setAttribute('aria-expanded', 'false');
        this.element.setAttribute('aria-label', this.labelOpenedValue);
    }
}
